import tipo_pago from "./tipo_pago"
import moneda from "./moneda"
import punto_venta from "./punto_venta"
import sucursal from "./sucursal"
export default {
    tipo_pago,
    moneda,
    punto_venta,
    sucursal
}